export default "__VITE_PUBLIC_ASSET__a94a4457__"